import React from 'react';
import {cloneDeep} from 'lodash';

import Input from "../../forms/Input";


export default class SelectRateAndTerm extends React.Component{

    static defaultProps = {
        config: []
    }

    getAllScopes = () => {
         let scopes = new Set(this.props.config.reduce((r,d) => {
               if (Array.isArray(d.scopes)) {
                  return [...r, ...d.scopes]
               } else {
                    return r
               }
        }, []));

         return [...scopes]
    }

    render() {

        return (
            <div className={'box select-rate-and-term'} style={{padding: 0}}>
                <table className={'table is-striped is-fullwidth'}>
                    <thead className={'term-header header has-text-white-bis has-background-primary'}>
                    <tr>
                        <th className={'h-title has-text-white-bis'}>
                            ESS Only Loan Term
                        </th>
                        {this.props.config.map(d => (
                            <th className={'h-column has-text-white-bis'}>
                                {d.term}
                            </th>
                        ))
                        }
                    </tr>
                    </thead>

                    <thead className={'rate-header header has-background-primary-light'}>
                    <tr>
                        <th className={'h-title'}>
                            Rate
                        </th>
                        {this.props.config.map(d => (
                            <th className={'h-column'}>
                                {Math.floor((d.rate * 100)) / 10000} %
                            </th>
                        ))
                        }
                    </tr>
                    </thead>

                    <tbody>
                        {this.getAllScopes().map(scope => (
                             <tr className={'scope-row'}>
                                  <td>
                                      {scope}
                                  </td>
                                 {this.props.config.map((d,i) => (
                                     <td
                                         onClick={() => {
                                             // we modify the whole prop object here and then kick it up for replacement.
                                             let {config} = this.props;
                                              let opt = cloneDeep(d);
                                             if (opt.selectedScopes.includes(scope)) {
                                                 opt.selectedScopes = opt.selectedScopes.filter(s => s !== scope)
                                             } else {
                                                 opt.selectedScopes = [...opt.selectedScopes, scope]
                                             }

                                             config[i] = opt;
                                             this.props.onSelection(cloneDeep(config));
                                         }}
                                         className={!d.scopes.includes(scope) ? 'disabled': 'cursor-is-pointer'}
                                     >
                                         {!d.scopes.includes(scope) ?
                                             <i className="fas fa-times"/> :

                                             d.selectedScopes.includes(scope) ?
                                             <i className="fas fa-check-square has-text-success"/> :
                                             <i className="far fa-square"/>
                                         }
                                     </td>
                                 ))}

                             </tr>
                        ))}

                    </tbody>

                </table>
            </div>
        )
     }

}


/*

this expect a json config prop in teh following format:


[
    {
        term: 5,
        rate: 2,
        scopes: ['solar', 'wind'] // name of the scopes
    }
    ... and so on
]*/
